<template>
    <div class="message-title py-2">
        <div class="warning-text">{{ toSentenceCase($t('planning.warnings.warning')) }}!</div>
        <div v-if="mergeTags">
            {{ toSentenceCase($t(descriptionText, { tagName, duplicateTagName })) }}
        </div>
        <div v-else>
            {{ descriptionText ? toSentenceCase($t(descriptionText)) : '' }}
        </div>
        <div v-if="!isEmpty(childDependencies)">
            <div v-if="deleteTag">
                {{ toSentenceCase($t(warningText, { tagName })) }}
            </div>
            <div v-else>
                {{ toSentenceCase($t(warningText)) }}
            </div>
            <ul>
                <li v-for="(count, entityName) in childDependencies" :key="entityName">
                    <span v-if="count">
                        {{ toSentenceCase($t(`pluralEntities.${entityName}`)) }}: {{ count }}
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { isEmpty } from 'lodash';

export default {
    props: {
        mergeTags: {
            type: Boolean,
            default: false,
        },
        deleteTag: {
            type: Boolean,
            default: false,
        },
        tagName: {
            type: String,
            default: '',
        },
        duplicateTagName: {
            type: String,
            default: '',
        },
        childDependencies: Object,
        descriptionText: String,
        warningText: String,
    },

    data: () => ({
        isEmpty,
    }),
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';

.warning-text {
    color: $negative-action;
}

.message-title {
    font-size: 1.4rem;
}
</style>
